import { ReactP5Wrapper } from "@p5-wrapper/react";
import React from "react";

const sketch = (p5) => {
    // Data
    let font;
    let pg;
    let animWidth = 2550;
    let animHeight = 490;

    // Props
    let width = 0;
    let height = 0;
    let backgroundColor = "#000000";
    let textColor = "#ffffff";

    // Tiles properties
    let tilesX = 20;
    let tilesY = 10;
    let tileW;
    let tileH;
    let tiles = [];

    p5.preload = () => {
        font = p5.loadFont("/fonts/F37Judge-BoldExtended.otf"); // Load font
    };

    p5.setup = () => {
        p5.createCanvas(width, height, p5.P2D);
        pg = p5.createGraphics(animWidth, animHeight);
        createTiles();
    };

    p5.updateWithProps = (props) => {
        if (props.width) {
            width = props.width;
        }
        if (props.height) {
            height = props.height;
        }
        if (props.backgroundColor) {
            backgroundColor = props.backgroundColor;
        }
        if (props.textColor) {
            textColor = props.textColor;
        }
    };

    function createTiles() {
        tileW = p5.round(animWidth / tilesX);
        tileH = p5.round(animHeight / tilesY);

        pg.clear();
        pg.background(backgroundColor);
        pg.fill(textColor);
        pg.textFont(font);
        pg.textSize(500);
        pg.textAlign(p5.CENTER, p5.CENTER);

        pg.text("CAMPUS", animWidth / 2, 180);

        tiles = [];
        for (let y = 0; y < tilesY; y++) {
            let row = [];
            for (let x = 0; x < tilesX; x++) {
                let sx = x * tileW;
                let sy = y * tileH;
                row.push(
                    pg.get(
                        sx - tileW,
                        sy - tileH,
                        tileW + tileW * 2,
                        tileH + tileH * 2
                    )
                );
            }
            tiles.push(row);
        }
    }

    p5.myCustomRedrawAccordingToNewPropsHandler = (props) => {
        if (props.width) width = props.width;
        if (props.height) height = props.height;
        if (props.backgroundColor) backgroundColor = props.backgroundColor;
        if (props.textColor) textColor = props.textColor;

        if (pg && (props.width || props.height)) {
            p5.resizeCanvas(width, height);
            createTiles();
        }
    };

    p5.draw = () => {
        p5.scale(width / animWidth, height / animHeight);
        p5.background(backgroundColor);

        let mX = 0;
        if (p5.mouseX !== 0) {
            mX = p5.map(p5.mouseX / width, 0, 1, -2, 1) * tileW;
        }

        for (let y = 0; y < tiles.length; y++) {
            for (let x = 0; x < tiles[0].length; x++) {
                let wave = p5.int(
                    p5.sin(p5.frameCount * 0.05 + x * y * 0.02) * tileW
                );
                // Mouse
                /*
				let wave = p5.int(
                    p5.sin(mX * 0.03 + x * y * 0.02) * tileW
                );
				*/
                p5.image(
                    tiles[y][x],
                    x * tileW,
                    y * tileH,
                    tileW,
                    tileH,
                    tileW - mX + wave,
                    tileH,
                    tileW,
                    tileH
                );
            }
        }
    };
};

class Animation extends React.PureComponent {
    render() {
        const { width, height, backgroundColor, textColor } = this.props;

        return (
            <ReactP5Wrapper
                sketch={sketch}
                width={width}
                height={height}
                backgroundColor={backgroundColor}
                textColor={textColor}
            />
        );
    }
}

export default Animation;
